(() => {
  if (window.__iconWithTextTooltipBound) return;
  window.__iconWithTextTooltipBound = true;

  document.addEventListener('pointerdown', (event) => {
    document.querySelectorAll('details.icon-with-text__tooltip[open]').forEach((details) => {
      if (details.contains(event.target)) return;
      details.removeAttribute('open');
    });
  });
})();
